module.exports = __webpack_public_path__ + "img/chair2.jpg.9270ddae.webp";